import { AnalyticsTracker } from '@backstage/core-plugin-api';

/**
 * Captures a search event with analytics including filter attributes
 *
 * @param analytics - The analytics API instance from useAnalytics()
 * @param result - The search result object from useSearch()
 * @param term - The search term
 * @param types - Array of search types (e.g., ['software-catalog', 'techdocs'])
 * @param filters - The search filters object
 */
export function captureSearchEvent(
  analytics: AnalyticsTracker,
  result: any,
  term: string,
  types: string[],
  filters: any,
): void {
  if (!result.loading && !result.error && result.value && term) {
    analytics.captureEvent('search', term, {
      value: result.value.numberOfResults ?? 0,
      attributes: {
        resultCount: result.value.numberOfResults ?? 0,
        searchTypes: types.join(','),
        ...(filters.name && { documentationName: String(filters.name) }),
        ...(filters.owner && { owner: String(filters.owner) }),
        ...(filters.kind && { kind: String(filters.kind) }),
        ...(filters.lifecycle && { lifecycle: String(filters.lifecycle) }),
      },
    });
  }
}
